import {Handler} from "../../Utils";
import {IFileOptions, IHandlers} from "../../../../example/services/ApiClient";

export interface ValidationError {
    message: string
}

export interface IDispatcher {
    onChange(id: string, value: any, valid: boolean, error: ValidationError | undefined): void;
    onBlur(id: string, value: any, valid: boolean, error: ValidationError | undefined): void;
    onVisit(id: string);
    onLoadFile(id:string, state: object): void;
    onAddValueRefresh(id: string, value: any, error: ValidationError | undefined);
    bind(name: string, handler: Handler): Handler;
    setError(id: string, value: any, error: { message } | undefined, skipCommonValidation: boolean): void;
    pullValue(control_id: string): any
    pullTableRows(control_id: string, field_id: string): Array<string>

    setFileValue(options: IFileOptions, value: any, fileId: string, handlers: IHandlers): string;
    isRemovePanelBlock(key: string, handlers: IHandlers): any;
    getFileUrl(controlId: string, fileName: string, timestamp ? : number): string;
    deleteFileValue(id: string, fileName: string, value: any, fileId: string, handlers: IHandlers) : any;
    hasRemoveBlock(key: string, handlers: IHandlers): any;
}

export abstract class Dispatcher implements IDispatcher {

    abstract onAddValueRefresh(id: string, value: any, error: ValidationError | undefined): void;

    abstract onChange(id: string, value: any, valid: boolean, error: ValidationError | undefined): void;

    abstract onBlur(id: string, value: any, valid: boolean, error: ValidationError | undefined): void;

    abstract onVisit(id: string);

    abstract setError(id: string, value: any, error: { message } | undefined, skipCommonValidation: boolean): void;

    abstract onLoadFile(id:string, state: object): void;

    public setFileValue: (options: IFileOptions, value: any, fileId: string, handlers: IHandlers) => string;
    public isRemovePanelBlock: (key: string, handlers: IHandlers) => any;
    public getFileUrl: (controlId: string, fileName: string, timestamp ? : number) => string;
    public deleteFileValue: (id: string, fileName: string, value: any, fileId: string, handlers: IHandlers) => any;
    public hasRemoveBlock: (key: string, handlers: IHandlers) => any;

    private events: {[name: string]: Handler[]} = {};

    bind(name: string, handler: Handler): Handler {

        let event = this.events[name];
        if(event == undefined) {
            event = [];
            this.events[name] = event;
        }

        event.push(handler);

        return function () {
            const i = event.indexOf(handler);
            event = event.splice(i, 1);
            this.events[name] = event;
        }
    }

    public invoke(name: string, ...args: any[]) {
        for(const ev of this.events[name]) {
            ev(...args);
        }
    }
    abstract pullValue(control_id: string): any
    abstract pullTableRows(control_id: string, field_id: string): Array<string>
}

export class ControlValueDispatcher extends Dispatcher{
    public controlVisited: (id: string) => void;

    addControlRefres: any;
    public addControlValue: (id:string, value:any, valid:boolean, error: ValidationError | undefined) => void;

    public addControlRefresh: (id:string, value:any, error: ValidationError | undefined) => void;

    public copyValue: (source: string, target:string) => void;

    public addFile: (id:string, state: object) => void;

    public error: (id: string, value: any, error: ValidationError | undefined, skipCommonValidation: boolean) => void;

    public setFileValue: (options: IFileOptions, value: any, fileId: string, handlers: IHandlers) => string;
    public isRemovePanelBlock: (key: string, handlers: IHandlers) => any;
    public getFileUrl: (controlId: string, fileName: string, timestamp ? : number) => string;
    public deleteFileValue: (id: string, fileName: string, value: any, fileId: string, handlers: IHandlers) => any;
    public hasRemoveBlock: (key: string, handlers: IHandlers) => any;

    onVisit(id: string) {
        this.controlVisited(id);
    }

    onChange(id: string, value: any, valid: boolean, error: ValidationError | undefined): void {}

    onBlur(id: string, value: any, valid: boolean, error: ValidationError): void {
        this.addControlValue(id, value, valid, error)
    }

    onLoadFile(id:string, state: object){
        this.addFile(id, state);
    }

    onAddValueRefresh(id: string, value: any, error: ValidationError | undefined): void {
        this.addControlRefresh(id, value, error);
    }

    setError(id: string, value: any, error: { message } | undefined, skipCommonValidation: boolean = false): void {
        this.error(id, value, error, skipCommonValidation);
    }

    pullValue(control_id: string): any{}
    pullTableRows(control_id: string, field_id: string): Array<string>{
        return []
    }
}
